module.exports = __webpack_public_path__ + "img/03.cad6f39e.png";